var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeveloperIcon = function SvgDeveloperIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#fff",
    rx: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5754CC",
    d: "M30.435 29.948v2.713c0 .4-.325.726-.726.726h-2.661v-7.874l.013.003a4.609 4.609 0 0 1 3.374 4.432Zm-18.87 0v2.713c0 .4.324.726.725.726h2.661v-7.874l-.012.003a4.609 4.609 0 0 0-3.374 4.432Zm12.58-4.642A3.149 3.149 0 0 1 21 28.451a3.149 3.149 0 0 1-3.145-3.145v-.594l-1.452.4v8.275h9.193v-8.274l-1.451-.4v.593Zm-4.839-.99v.99a1.693 1.693 0 0 0 3.387 0v-.99a5.543 5.543 0 0 1-3.387 0Zm5.806-5.3v-1.451h-8.225v1.451A4.117 4.117 0 0 0 21 23.13a4.117 4.117 0 0 0 4.113-4.113Zm1.21-4.354h-.726v-.484a4.598 4.598 0 0 0-1.693-3.558v.896a.726.726 0 1 1-1.452 0V9.34c0-.4-.325-.726-.726-.726h-1.451c-.401 0-.726.325-.726.726v2.177a.726.726 0 1 1-1.452 0v-.896a4.599 4.599 0 0 0-1.693 3.558v.483h-.726a.726.726 0 0 0 0 1.452h10.645a.726.726 0 0 0 0-1.451Z"
  })));
};
export default SvgDeveloperIcon;